import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { DollarSign } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';

interface InvoiceAmountPreviewProps {
  currentInvoiceAmount: number;
  remainingAfterInvoice: number;
  remainingBalance: number;
}

const InvoiceAmountPreview: React.FC<InvoiceAmountPreviewProps> = ({
  currentInvoiceAmount,
  remainingAfterInvoice,
  remainingBalance
}) => {
  return (
    <Card className="bg-blue-50 border-blue-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-blue-800">
          <DollarSign className="h-5 w-5" />
          Invoice Amount Preview
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="text-sm text-muted-foreground">Current Balance</p>
            <p className="text-xl font-bold text-blue-600">{formatCurrency(remainingBalance)}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Invoice Amount</p>
            <p className="text-xl font-bold text-green-600">{formatCurrency(currentInvoiceAmount)}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Remaining After Invoice</p>
            <p className="text-xl font-bold text-orange-600">{formatCurrency(remainingAfterInvoice)}</p>
            <Badge variant={remainingAfterInvoice > 0 ? "secondary" : "default"} className="mt-1">
              {remainingAfterInvoice > 0 ? "Partial Invoice" : "Full Invoice"}
            </Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default InvoiceAmountPreview;
